document.addEventListener('DOMContentLoaded', function () {
  // Get URL parameters
  const urlParams = new URLSearchParams(window.location.search);
  const filterParams = {};

  // Get option names dynamically from the DOM
  const getOptionNames = () => {
    const optionGroups = document.querySelectorAll('.product-form__input');
    const options = {};
    
    optionGroups.forEach(group => {
      const legend = group.querySelector('legend span');
      if (legend) {
        const optionName = legend.textContent.split(':')[0].trim().toLowerCase();
        const urlKey = optionName.replace(/\s+/g, '_');
        options[urlKey] = optionName;
      }
    });
    
    return options;
  };

  const optionMapping = getOptionNames();
  const reverseOptionMapping = Object.entries(optionMapping).reduce((acc, [key, value]) => {
    acc[value.toLowerCase()] = key;
    return acc;
  }, {});

  // Function to update URL with variant selection
  const updateURL = (variantGroups) => {
    const newParams = new URLSearchParams(window.location.search);
    
    // Remove existing filter parameters
    for (const [key] of newParams.entries()) {
      if (key.startsWith('filter.v.option.')) newParams.delete(key);
    }

    // Add current selections
    variantGroups.forEach((group) => {
      const legend = group.querySelector('legend');
      if (!legend) return;

      const optionText = legend.querySelector('span').textContent.split(':')[0].trim();
      const selectedRadio = group.querySelector('input[type="radio"]:checked');

      if (selectedRadio && reverseOptionMapping[optionText.toLowerCase()]) {
        newParams.set(`filter.v.option.${reverseOptionMapping[optionText.toLowerCase()]}`, selectedRadio.value);
      }
    });

    window.history.replaceState({}, '', `${window.location.pathname}${newParams.toString() ? '?' + newParams.toString() : ''}`);
  };

  // Collect filter parameters
  for (const [key, value] of urlParams.entries()) {
    if (key.startsWith('filter.v.option.')) {
      filterParams[key.replace('filter.v.option.', '').toLowerCase()] = decodeURIComponent(value).toLowerCase();
    }
  }

  // Handle variant radio buttons
  const variantRadios = document.querySelectorAll('.product-form__input');
  
  variantRadios.forEach((group) => {
    const radioInputs = group.querySelectorAll('input[type="radio"]');
    const legend = group.querySelector('legend');
    const selectedVariantSpan = legend?.querySelector('.selected-variant');
    
    // Skip single option variants
    if (Array.from(radioInputs).filter(radio => radio.getAttribute('availability') !== 'false').length === 1) return;

    // Add change listeners
    radioInputs.forEach(radio => {
      radio.addEventListener('change', () => radio.checked && updateURL(variantRadios));
    });

    // Process URL parameters
    if (Object.keys(filterParams).length > 0) {
      const optionText = legend?.querySelector('span')?.textContent.split(':')[0].toLowerCase().trim();
      
      if (filterParams[optionText]) {
        const filterValue = filterParams[optionText];
        let foundMatch = false;

        // Try exact match
        radioInputs.forEach(radio => {
          const radioValue = radio.value.toLowerCase();
          if (radioValue === filterValue) {
            radio.checked = true;
            radio.classList.add('selected');
            radio.click();
            foundMatch = true;
            selectedVariantSpan && (selectedVariantSpan.textContent = radio.value);
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });

        // Try partial match
        if (!foundMatch) {
          radioInputs.forEach(radio => {
            const radioValue = radio.value.toLowerCase();
            if (radioValue.includes(filterValue) || filterValue.includes(radioValue)) {
              radio.checked = true;
              radio.classList.add('selected');
              radio.click();
              selectedVariantSpan && (selectedVariantSpan.textContent = radio.value);
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        }
      } else {
        // Clear selection if no parameter
        radioInputs.forEach(radio => {
          radio.checked = false;
          radio.classList.remove('selected');
          selectedVariantSpan && (selectedVariantSpan.textContent = '');
        });
      }
    }
  });

  // Handle color selection
  setTimeout(() => {
    if (!filterParams.color) {
      document.querySelector('.product.grid .product__media-wrapper').classList.remove('invisible');
    }
    document.querySelectorAll('input[name="Color"]').forEach(radio => {
      if (radio.classList.contains('selected')) {
        const label = document.querySelector(`label[for="${radio.id}"]`);
        label?.click();
          const selectedVariantSpan = document.querySelector('.varaint-color .selected-variant');
          if (selectedVariantSpan) {
            selectedVariantSpan.textContent = radio.value;
          }
          document.querySelector('.product.grid .product__media-wrapper').classList.remove('invisible');
        radio.classList.add('selected');
      }
    });
  }, 100);
});